import React from "react";

const VoucherPlus = ({ ...rest }) => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path
                opacity="0.2"
                d="M10.0547 24.5938V0.945312H14.9062V24.5938H10.0547ZM0.9375 15.125V10.4141H24.0234V15.125H0.9375Z"
                fill="#0F1016"
            />
        </svg>
    );
};

export default VoucherPlus;
